/**
 * Badges reutilizáveis do editor de Playbooks (Brief 4 · Tela 1).
 *
 * Espelham componentes do gabarito (components-4.jsx: OperationModeBadge,
 * ValidationModeBadge, AppetiteBadge, ChecklistPriorityBadge), porém ligados
 * aos enums REAIS do backend (H_a..H_d / none·ai_optional·ai_required /
 * none·conservative·balanced·active) — não aos R2/R3/R4 do protótipo.
 *
 * Estilo via classes escopadas em playbooks-4.css (sem valores inline).
 */

import { operationModeLabel } from './playbook-labels';

export function OperationModeBadge({ mode }: { mode: string }): JSX.Element {
  return (
    <span
      className={`pb-badge pb-badge--mode pb-badge--mode-${mode}`}
      title={operationModeLabel(mode).desc}
    >
      {mode}
    </span>
  );
}

export function ValidationModeBadge({ mode }: { mode: string }): JSX.Element {
  return <span className={`pb-badge pb-badge--val pb-badge--val-${mode}`}>{mode}</span>;
}

export function AppetiteBadge({ level }: { level: string }): JSX.Element {
  return <span className={`pb-badge pb-badge--appetite pb-badge--appetite-${level}`}>{level}</span>;
}

/**
 * Prioridade de item de checklist. Backend (ChecklistTemplateItem) só tem o
 * booleano `isCritical` — mapeamos para crítico/normal (não fabricamos a escala
 * low/medium/high/critical do protótipo).
 */
export function ChecklistPriorityBadge({ isCritical }: { isCritical: boolean }): JSX.Element {
  return (
    <span
      className={`pb-badge pb-badge--priority pb-badge--priority-${isCritical ? 'critical' : 'normal'}`}
    >
      {isCritical ? 'Crítico' : 'Normal'}
    </span>
  );
}
